import { render } from "./UploadingVideo.vue?vue&type=template&id=8f65b202&scoped=true"
import script from "./UploadingVideo.vue?vue&type=script&lang=js"
export * from "./UploadingVideo.vue?vue&type=script&lang=js"

import "./UploadingVideo.vue?vue&type=style&index=0&id=8f65b202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f65b202"]])

export default __exports__